{
  "version": 1,
  "asset_id": "85769471-a9c7-4998-80ec-f7fcbf90af0e",
  "project_id": "949ac23c-9e33-4376-b191-e19499cf4fa3",
  "url": "/__l5e/assets-v1/85769471-a9c7-4998-80ec-f7fcbf90af0e/esenyurt-hizli-elektrikci-7-24-dukkan-4.jpg",
  "r2_key": "a/v1/949ac23c-9e33-4376-b191-e19499cf4fa3/85769471-a9c7-4998-80ec-f7fcbf90af0e/esenyurt-hizli-elektrikci-7-24-dukkan-4.jpg",
  "original_filename": "esenyurt-hizli-elektrikci-7-24-dukkan-4.jpg",
  "size": 525489,
  "content_type": "image/jpeg",
  "created_at": "2026-09-12T10:56:11Z"
}
